import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.303 14.535a.994.994 0 01-.587-.195.984.984 0 01-.363-1.118l1.186-3.654L1.43 7.309a.987.987 0 01-.363-1.119.987.987 0 01.952-.69H5.86l1.19-3.655a.983.983 0 01.95-.69c.442 0 .815.27.951.69L10.138 5.5h3.844c.44 0 .814.271.95.69a.986.986 0 01-.363 1.119L11.46 9.568l1.188 3.654a.984.984 0 01-.364 1.118.985.985 0 01-1.175 0L8 12.082 4.89 14.34a.998.998 0 01-.587.195z",
    clipRule: "evenodd"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.455 21.803c-.307 0-.613-.097-.881-.292a1.476 1.476 0 01-.545-1.677l1.78-5.482-4.664-3.388A1.48 1.48 0 011.6 9.286 1.48 1.48 0 013.028 8.25h5.764l1.782-5.482A1.475 1.475 0 0112 1.732c.663 0 1.223.407 1.427 1.037l1.78 5.48h5.765c.662 0 1.22.408 1.426 1.037a1.48 1.48 0 01-.544 1.678l-4.664 3.388 1.78 5.482a1.476 1.476 0 01-.544 1.677 1.478 1.478 0 01-1.763 0L12 18.123 7.336 21.51a1.496 1.496 0 01-.881.292z",
    clipRule: "evenodd"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.91 43.605a2.983 2.983 0 01-1.762-.584 2.952 2.952 0 01-1.09-3.354l3.56-10.964-9.328-6.776a2.961 2.961 0 01-1.088-3.356A2.96 2.96 0 016.056 16.5h11.528l3.564-10.964A2.95 2.95 0 0124 3.463c1.326 0 2.446.814 2.854 2.074l3.56 10.962h11.53c1.324 0 2.442.814 2.852 2.072a2.958 2.958 0 01-1.088 3.356l-9.328 6.776 3.562 10.964a2.952 2.952 0 01-1.09 3.354 2.955 2.955 0 01-3.526 0L24 36.245l-9.328 6.776a2.992 2.992 0 01-1.762.584z",
    clipRule: "evenodd"
  }))
};
export var RatingFilled = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});